// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorsCard-cls1_YJV","cls2":"AuthorsCard-cls2_dI2 AuthorsCard-cls1_YJV"};